module.exports = __webpack_public_path__ + "static/media/logo-design.433ef198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/logo-design.svg
// module id = 322
// module chunks = 0